import { render, staticRenderFns } from "./TeamInfo.vue?vue&type=template&id=1054ee9d&scoped=true"
import script from "./TeamInfo.vue?vue&type=script&lang=js"
export * from "./TeamInfo.vue?vue&type=script&lang=js"
import style0 from "./TeamInfo.vue?vue&type=style&index=0&id=1054ee9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054ee9d",
  null
  
)

export default component.exports